import { apiClient } from "lib/apiClient";
import { assistantPageCodeEnum } from "features/AssistantPages/constantTypes";

interface IOpenChatKitSessionParams {
  code: assistantPageCodeEnum;
  propertyId?: string;
}

export interface IChatKitSession {
  clientSecret: string;
  lastThreadId: string | null;
}

export const openChatKitSession = async ({
  code,
  propertyId,
}: IOpenChatKitSessionParams): Promise<IChatKitSession> => {
  const response = await apiClient.post(
    `/assistant/pages/${code}/chatkit/session/open`,
    { propertyId }
  );

  return response.data;
};
